import React from "react"
import { Dropdown } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { setAIBaseRequest } from "../../actions/multiAiBase"
import Tooltip from "@material-ui/core/Tooltip"

export const MultiBaseDropdown = ({ callback = () => {} }) => {
	const multiBaseList = useSelector((state) => state.multiBase.multiBaseList)
	const selectedBaseName = useSelector((state) => state.multiBase.selectedBase?.friendly_name)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase?.project_id)
	const dispatch = useDispatch()

	const handleBaseChange = (clickedBase) => {
		const { project_id } = clickedBase
		const previousBaseId = selectedBaseId || project_id
		if (project_id !== selectedBaseId) {
			const updatedBase = { ...clickedBase, prev: previousBaseId }
			dispatch(setAIBaseRequest(updatedBase)) //API call for newly selected AI base
			localStorage.setItem("selectedProject", JSON.stringify(updatedBase))
			callback()
		}
	}

	const dropDownItems = multiBaseList.map((base, index) => (
		<div key={index}>
			<Dropdown.Item
				id={base.project_id}
				data-cy={base.project_id}
				active={base.project_id === selectedBaseId}
				onClick={() => {
					handleBaseChange(base)
				}}
			>
				{base.friendly_name}
			</Dropdown.Item>
			{index + 1 < multiBaseList.length && <Dropdown.Divider />}
		</div>
	))
	return (
		<>
			<Dropdown data-cy="multi-base-dropdown" className="d-inline multi-base-dropdown qa-multibase-list">
				<Tooltip title={selectedBaseName || "Select Ai Base"} placement="top" arrow>
					<Dropdown.Toggle>{selectedBaseName || "Select Ai Base"}</Dropdown.Toggle>
				</Tooltip>
				<Dropdown.Menu>{dropDownItems}</Dropdown.Menu>
			</Dropdown>
		</>
	)
}
